import React, { useRef, useEffect, useState, useContext, useCallback } from 'react';

import { useHistory } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { DialogCursos } from './DialogCursos';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss';
import { PermissaoLoader } from "./PermissaoLoader";
import { permissions_check } from "../utils/rotas_permissao";

import api from '../api/api';

import { FilterContext } from '../contexts/FilterContext';
import { AuthContext } from '../contexts/AuthContext';

export const TabelaCursos = () => {
    const toast = useRef(null);
    const [cursosTotal, setCursosTotal] = useState([]);
    const [cursos, setCursos] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null)
    const [dt, setDt] = useState(null);
    const history = useHistory();
    const [showListaCursos, setShowListaCursos] = useState(false);
    const { user, permissoes } = useContext(AuthContext);
    const [showActionsColumn, setShowActionsColumn] = useState(true);
    const [sortable, setSortable] = useState('ASC');
    const [sortableCampo, setSortableCampo] = useState('id');
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [tipos, setTipos] = useState([]);
    const filterStatus = renderFilterStatus();
    const { filter, setFilter } = useContext(FilterContext);

    const header = (
      <div className="p-grid p-col-12 p-m-0 p-p-0">
        <div>
          <h2 className="p-my-0">Cursos...</h2>
        </div>
        <div className="p-my-0 p-grid p-dir-rev p-col">
          <div className="p-m-2">
            <PermissaoLoader
              rota="cursos"
              acao="criar"
              onClick={() => history.push('/cursos/create')}
            />
          </div>
          <div className="p-m-2">
            <Button
              label="Limpar Filtros"
              className="p-mb-2 p-button-primary"
              iconPos="left"
              type="button"
              onClick={() => handleLimparClick()}
            />
          </div>
        </div>
      </div>
    );

    const handleLimparClick = () => {
        setFilter({
            first: 0,
            rows: 20,
            sortField: null,
            sortOrder: null,
            filters: {
            },

        });
        setSelectedStatus(null);
    }

    const getCursos = useCallback(
        async (event) => {
            setIsLoading(true);
            setCursos([]); // limpa a lista

            const page = event?.page ?? 0;
            const isFirstLoad = event === undefined;

            try {
                let response;
                const baseParams = `sort=${sortableCampo},${sortable}`;
                const pageParam = `page=${page}`;

                // 1. Montar corpo da pesquisa (se houver filtro)
                const pesquisa = filter?.filters
                    ? {
                        id: filter.filters['id']?.value ?? null,
                        nome: filter.filters['nome']?.value ?? "",
                        obs: filter.filters['obs']?.value ?? "",
                        sigla: filter.filters['sigla']?.value ?? "",
                        tipoId: filter.filters['tipoId']?.value ?? null,
                    }
                    : null;

                // 2. Escolher endpoint e método
                if (pesquisa) {
                    const url = isFirstLoad
                        ? `curso/searchCurso/${sortable}/${sortableCampo}?`
                        : `curso/searchCurso/${sortable}/${sortableCampo}?${pageParam}`;

                    response = await api.post(url, pesquisa);
                } else {
                    const url = isFirstLoad
                        ? `curso?${baseParams}`
                        : `curso?${pageParam}&${baseParams}`;                        

                    response = await api.get(url);
                }

                // 3. Extrair dados paginados
                const content = response.data.content ?? response.data;
                const total = response.data.totalElements ?? content.length;

                setCursos(content);
                setTotalRecords(total);

                // Atualiza índice de paginação apenas se for evento de tabela
                if (event) {
                    setFirst(event.first);
                }
            } catch (error) {
                console.error("Erro ao carregar cursos:", error);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Falha ao carregar cursos',
                });

                // Opcional: fallback para lista básica
                try {
                    const fallback = await api.get(`curso?sort=${sortableCampo},${sortable}`);
                    const content = fallback.data.content ?? fallback.data;
                    setCursos(content);
                    setTotalRecords(fallback.data.totalElements ?? content.length);
                } catch (fallbackError) {
                    // silêncio ou outro toast
                }
            } finally {
                setIsLoading(false);
            }
        },
        [filter, sortable, sortableCampo, toast]
    );

    useEffect(() => {
        const fetchCursos = async () => {
            try {
                await getCursos();

            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchCursos();

    }, [getCursos])

    function renderFilterStatus() {
        return (
            <Dropdown
                value={selectedStatus}
                options={tipos}
                onChange={(e) => onStatusSearchChange(e)}
                placeholder="Selecione um tipo"
                className="p-column-filter"
                showClear={true} />
        );
    }

    const onStatusSearchChange = (event) => {
        if (event.value !== null) {
            dt.filter(event.value, 'tipoId', 'equals');
            setSelectedStatus(event.value);
        }
        else
            dt.filter(null, 'tipoId', 'equals');
    }

    const actionBodyTemplate = (rowData) => {
        const hasEditPermission = permissions_check(
            "cursos",
            "editar",
            permissoes
        );
        const hasDeletePermission = permissions_check(
            "cursos",
            "deletar",
            permissoes
        );
        if (!hasEditPermission && !hasDeletePermission) {
            setShowActionsColumn(false);
        } else {
            return (
                <div className="actions">
                    {hasEditPermission ? (
                        <Button
                            icon="pi pi-pencil"
                            className="p-button-rounded p-mr-2 edit-btn"
                            onClick={() => handleEditClick(rowData)}
                        />
                    ) : (
                        <></>
                    )}
                    {hasDeletePermission ? (
                        <Button
                            icon="pi pi-trash"
                            className="p-button-rounded p-mr-2 p-button-danger"
                            loading={isDeleting}
                            onClick={() => handleDeleteClick(rowData)}
                        />
                    ) : (
                        <></>
                    )}
                </div>
            );
        }
    };

    const codBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const nomeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome</span>
                    <span className="table-data">{rowData.nome}</span>
                </p>
            </React.Fragment>
        );
    }

    const observacaoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Observação</span>
                    <span className="table-data">{rowData.obs}</span>
                </p>
            </React.Fragment>
        );
    }

    const siglaBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Sigla</span>
                    <span className="table-data">{rowData.sigla}</span>
                </p>
            </React.Fragment>
        );
    }

    const tipoBodyTemplate = (rowData) => {        
        
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Tipo</span>
                    <span className="table-data">{rowData.tipo.nome}</span>
                </p>
            </React.Fragment>
        );
    }

    const onSort = (event) => {
        setSortableCampo(event.sortField);
        if (sortable === 'ASC') {
            setSortable('DESC')
        } else if (sortable === 'DESC') {
            setSortable('ASC')
        }
    }

    const onFilter = (event) => {
        event['first'] = 0;
        // setLazyParams(event);
        setFilter(event);
    }


    const handleEditClick = (data) => {

        history.push(`/cursos/edit/${data.id}`);
    }

    const handleDeleteClick = (data) => {

        data['userEmail'] = user.email

        confirmDialog({
            message: `Você tem certeza que quer remover ${data.nome}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {

                    await api.delete(`curso/${data.id}`);
                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `Curso ${data.nome} removido(a) com sucesso` });
                    getCursos()
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover o curso', detail: error.response.data });
                }

                setIsDeleting(false);
            },
            reject: () => { return }
        });
    }

    const handlePrintClick = () => {
        setShowListaCursos(true);
    }

    const getCursosAll = useCallback(async () => {
        try {
            const response = await api.get(`curso/cursoAll`);
            setCursosTotal(response.data)
        }
        catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter cursos', detail: error.toString() });
        }
    }, []);

    const getTipos = useCallback(async () => {
        const response = await api.get(`tipo-cursos`);
        setTipos(response.data.map(tipos => {
            var Tipos = { label: '', value: '' };
            Tipos.label = tipos.nome
            Tipos.value = tipos.id

            return Tipos
        }))
        filter.filters !== undefined && (filter.filters.tipo !== undefined && filter.filters.tipo.value != null) ? setSelectedStatus(filter.filters.tipo.value) : setSelectedStatus(null)
    }, [filter]);

    useEffect(() => {

        async function cursos() {
            await getCursosAll();
            await getTipos();
        }
        cursos();

    }, [getCursosAll, getTipos])

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

                <DialogCursos
                    visible={showListaCursos}
                    setVisible={setShowListaCursos}
                    curso={cursosTotal}
                />
                <div className="p-my-0 p-dir-rev p-col">
                    <div className="p-my-0">
                        <Button
                            textalign="center"
                            icon="pi pi-print"
                            className="p-button-secondary"
                            style={{ width: '35px' }}
                            onClick={handlePrintClick}
                            tooltip="Gerar relatório"
                            tooltipOptions={{ position: 'top' }}
                        />
                    </div>
                </div>

                <Toast ref={toast} position="bottom-right" />

                <Toast ref={confirmationToast} position="bottom-center" />

                <div className="card p-col-12 datatable-responsive-demo">

                    <div className="p-fluid">

                        <DataTable
                            totalRecords={totalRecords}
                            lazy="true"
                            first={first}
                            onPage={getCursos}
                            ref={(element) => setDt(element)}
                            header={header}
                            value={cursos}
                            filterDisplay="row"
                            className="p-datatable-responsive-demo"
                            emptyMessage="Nenhum curso encontrado"
                            loading={isLoading}
                            dataKey="id"
                            paginator
                            rows={20}
                            currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} cursos`}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            // rowsPerPageOptions={[10, 20, 30]} 
                            onSort={onSort}
                            onFilter={onFilter}
                            filters={filter.filters}
                        >

                            <Column
                                field="id"
                                header="Código"
                                sortable={sortable}
                                body={codBodyTemplate}
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder={filter.filters !== undefined && (filter.filters.id !== undefined && filter.filters.id.value != null) ? filter.filters.id.value : "Pesquisar pelo Código"}

                            />

                            <Column
                                field="nome"
                                header="Nome"
                                sortable={sortable}
                                body={nomeBodyTemplate}
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder={filter.filters !== undefined && (filter.filters.nome !== undefined && filter.filters.nome.value !== "") ? filter.filters.nome.value : "Pesquisar pelo nome"}

                            />


                            <Column
                                field="obs"
                                header="Observação"
                                sortable={sortable}
                                body={observacaoBodyTemplate}
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder={filter.filters !== undefined && (filter.filters.obs !== undefined && filter.filters.obs.value !== "") ? filter.filters.obs.value : "Pesquisar pela observação"}

                            />

                            <Column
                                field="sigla"
                                header="Sigla"
                                sortable={sortable}
                                body={siglaBodyTemplate}
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder={filter.filters !== undefined && (filter.filters.sigla !== undefined && filter.filters.sigla.value !== "") ? filter.filters.sigla.value : "Pesquisar pela observação"}

                            />

                            <Column
                                field="tipo"
                                header="Tipo"
                                sortable={sortable}
                                body={tipoBodyTemplate}
                                filter
                                filterMatchMode="custom"
                                filterElement={filterStatus}

                            />

                            {showActionsColumn && (<Column
                                header="Ações"
                                body={actionBodyTemplate}
                            />)}

                        </DataTable>

                    </div>
                </div>
            </div>

        </>
    );
}